export const PASSWORD_CHECKER_COLORS = {
    empty: '#9E9E9E',
    weak: '#e16363',
    medium: '#f9b763',
    strong: '#55b055',
}

/**
 * @param {string} password
 * @returns {number} 0–5
 */
export function passwordComplexityScore(password) {
    const pw = password ?? ''
    return (
        (/.{8,}/.test(pw) ? 1 : 0) +
        (/.*[A-Z]/.test(pw) ? 1 : 0) +
        (/.*[a-z]/.test(pw) ? 1 : 0) +
        (/.*[0-9]/.test(pw) ? 1 : 0) +
        (/[^A-Za-z0-9]/.test(pw) ? 1 : 0)
    )
}

export function passwordStrengthTier(password, score) {
    if (!password || password.length === 0) {
        return 'empty'
    }
    if (score < 3) {
        return 'weak'
    }
    if (score < 5) {
        return 'medium'
    }
    return 'strong'
}

export function passwordStatusForTier(tier, labels) {
    if (tier === 'empty') {
        return '\u00A0'
    }
    if (tier === 'weak') {
        return labels.weak
    }
    if (tier === 'medium') {
        return labels.medium
    }
    return labels.strong
}

/**
 * Alpine component: first password field, visibility toggle, and strength meter.
 * Expects a sibling/preceding JSON script#password-checker-server-data with
 * passwordCheckerWeak, passwordCheckerMedium, passwordCheckerStrong, optional initialPassword.
 */
export default function registerPasswordChecker(Alpine) {
    Alpine.data('passwordChecker', () => ({
        password: '',
        showPassword: false,
        checkerLabels: { weak: '', medium: '', strong: '' },

        init() {
            const el = document.getElementById('password-checker-server-data')
            if (!el) {
                return
            }
            const data = JSON.parse(el.textContent)
            this.checkerLabels = {
                weak: data.passwordCheckerWeak ?? '',
                medium: data.passwordCheckerMedium ?? '',
                strong: data.passwordCheckerStrong ?? '',
            }
            if (typeof data.initialPassword === 'string') {
                this.password = data.initialPassword
            }
        },

        get passwordComplexityScore() {
            return passwordComplexityScore(this.password)
        },

        get passwordStrengthTier() {
            return passwordStrengthTier(this.password, this.passwordComplexityScore)
        },

        get passwordBarFillPercent() {
            return (this.passwordComplexityScore / 5) * 100
        },

        get passwordBarColor() {
            return PASSWORD_CHECKER_COLORS[this.passwordStrengthTier] ?? PASSWORD_CHECKER_COLORS.empty
        },

        get passwordStatusText() {
            return passwordStatusForTier(this.passwordStrengthTier, this.checkerLabels)
        },

        get passwordStatusColor() {
            if (this.passwordStrengthTier === 'empty') {
                return PASSWORD_CHECKER_COLORS.empty
            }
            return this.passwordBarColor
        },
    }))
}
